import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, ViewChild, Renderer2, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { SendEmailService } from "./send-email.service";
import { EmailAddress } from "../../model/EmailAddress";
import { checkValidEmail } from "../../helpers/check-valid-email.helper";
import { EmailService } from "../shared-emails/email.service";
import { AutoComplete } from "primeng/autocomplete";
import { ConfigurationService } from "src/app/configurations/configurationService";

@Component({
    selector: "app-send-email",
    templateUrl: "./send-email.component.html",
    styleUrls: ["./send-email.component.scss"],
})
export class SendEmailComponent implements OnInit, OnChanges {
    @Input() displayNewEmail: boolean;
    @Input() header: string;
    @Input() emailTo;
    @Input() subject;
    @Input() content;
    @Input() objectId: number;
    @Input() objectTypeId: number;
    @Input() emailAttachments: any;

    @Output() onSendComplete = new EventEmitter();
    @Output() onCancel = new EventEmitter();

    @ViewChild("toAutocomplete") toAutocomplete: AutoComplete;
    @ViewChild("ccAutocomplete") ccAutocomplete: AutoComplete;
    @ViewChild("bccAutocomplete") bccAutocomplete: AutoComplete;

    @ViewChild("editor") editor: any;

    emailForm: FormGroup;
    showCc = false;
    showBcc = false;
    disableEmailFrom = true;

    toRecipients: EmailAddress[] = [];
    ccRecipients: EmailAddress[] = [];
    bccRecipients: EmailAddress[] = [];
    allRecipients: EmailAddress[] = [];
    allRecipientsDefaults: EmailAddress[] = [];
    emailList: EmailAddress[] = [];
    validEmailCheck: boolean;
    allVendorSMTP;

    constructor(
        public app: AppMainComponent,
        private sendEmailService: SendEmailService,
        private fb: FormBuilder,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private emailService: EmailService,
        private configService: ConfigurationService,
        private renderer: Renderer2,
    ) { }


    ngOnInit(): void {
        this.initForm();
        this.getVendorRegistration();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayNewEmail && changes.displayNewEmail.currentValue) {
            this.displayNewEmail = changes.displayNewEmail.currentValue;
            this.initForm();
            this.getVendorRegistration();
        }
    }

    initForm() {
        this.emailForm = this.fb.group({
            id: [0],
            emailFrom: ["", Validators.required],
            subject: ["", Validators.required],
            content: ["", Validators.required],
        });
        this.initDefaultData();

        if (this.emailTo) {
            this.setDefaultEmailToValue(this.emailTo);
        }
        if (this.subject) {
            this.setEmailSubject();
        }
        if (this.content) {
            this.setContentInEditor(this.content);
        }
    }
    initDefaultData() {
        this.toRecipients = [];
        this.ccRecipients = [];
        this.bccRecipients = [];
        this.showCc = false;
        this.showBcc = false;
    }

    setEmailSubject() {
        this.emailForm.patchValue({
            subject: this.subject,
        });
    }

    setContentInEditor(text: any) {
        setTimeout(() => {
            const _quill = this.editor.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, "innerHTML", text);
        });
    }

    getVendorRegistration() {
        this.appMainService.isShowSpinner("loadVendorRegistration");
        this.configService.getAllVendorSMTPRegistration().subscribe(
            (res) => {
                this.allVendorSMTP = res;
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.setDefaultEmailFrom(this.allVendorSMTP);
            },
            (err) => {
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            },
        );
    }

    setDefaultEmailToValue(emailTo) {
        if (!emailTo) return;
        let obj = {
            id: 0,
            name: emailTo,
            emailAddress: emailTo,
        };
        this.toRecipients.push(obj);
    }

    setDefaultEmailFrom(allVendorSMTP) {
        const defaultSMTP = allVendorSMTP.find((r) => r.isDefault == true);
        this.emailForm?.controls?.emailFrom?.setValue(defaultSMTP);
        this.onChangeEmailFrom();
    }

    onChangeEmailFrom() {
        this.ccRecipients = [];
        this.bccRecipients = [];
        // emailcc and email bcc are comma separated values
        let emailCC = this.emailForm.controls.emailFrom.value?.emailCC?.split(",");
        let emailBCC = this.emailForm.controls.emailFrom.value?.emailBCC?.split(",");
        emailCC?.forEach((cc) => {
            if (cc) {
                let obj = {
                    id: 0,
                    name: cc,
                    emailAddress: cc,
                };
                this.ccRecipients.push(obj);
            }
        });
        emailBCC?.forEach((bcc) => {
            if (bcc) {
                let obj = {
                    id: 0,
                    name: bcc,
                    emailAddress: bcc,
                };
                this.bccRecipients.push(obj);
            }
        });
    }

    sendEmail() {
        if (this.emailAttachments && this.emailAttachments.length) {
            const emailToArr = this.toRecipients && this.toRecipients.length > 0 ? this.toRecipients?.map((cc) => cc.emailAddress) : [];
            const emailCCArr = this.ccRecipients && this.ccRecipients.length > 0 ? this.ccRecipients?.map((cc) => cc.emailAddress) : [];
            const emailBCCArr = this.bccRecipients && this.bccRecipients.length > 0 ? this.bccRecipients?.map((cc) => cc.emailAddress) : [];
            const emailAttachMentObj = [];
            this.emailAttachments.forEach((a) => {
                const obj = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: new Date().toISOString(),
                    updatedDate: new Date().toISOString(),
                    name: a.name,
                    guidName: "",
                    location: "",
                    content: a.attachment ? a.attachment.output("datauristring") : "",
                    extension: a.extension,
                    mediaType: "application/pdf",
                    sizeInBytes: 0,
                    description: "",
                    statusId: 1,
                    status: null,
                    isValid: true,
                    validFromDate: new Date().toISOString(),
                    validToDate: new Date().toISOString(),
                    parentFolderId: 0,
                    isFolder: true,
                    isCloudUploaded: true,
                    organizationId: 0,
                    downloadCount: 0,
                    downloadLink: "",
                    childFiles: null,
                    childFolders: null,
                    createdByUser: this.app.user.userId,
                    updatedByUser: "",
                };
                emailAttachMentObj.push(obj);
            });
            const req = [
                {
                    from: [this.emailForm.controls.emailFrom.value.emailId],
                    to: emailToArr,
                    cc: emailCCArr,
                    bcc: emailBCCArr,
                    subject: this.emailForm.controls.subject.value,
                    content: this.emailForm.controls.content.value,
                    attachments: emailAttachMentObj,
                },
            ];

            this.appMainService.isShowSpinner("sendEmail");
            this.sendEmailService.sendEmail(req).subscribe(
                (res) => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Email sent successfully...",
                    });
                    this.appMainService.isHideSpinner("sendEmail");
                    this.resetEmailForm();
                    this.initDefaultData();
                    this.onSendComplete.emit(res);
                },
                (err) => {
                    this.appMainService.isHideSpinner("sendEmail");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                },
            );
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "No Attachment found...",
            });
        }
    }

    resetData() {
        this.resetEmailForm();
    }

    resetEmailForm() {
        this.emailForm.reset();
    }

    cancel() {
        this.resetEmailForm();
        this.initDefaultData();
        this.onCancel.emit({});
    }

    onClickShowCc(): void {
        this.showCc = !this.showCc;
    }

    onClickShowBcc(): void {
        this.showBcc = !this.showBcc;
    }

    emailListDropdown(query) {
        if (this.objectId && this.objectTypeId) {
            this.emailService.getEmailListDropdown(this.objectId, this.objectTypeId).subscribe((response: any) => {
                if (!response) {
                    this.emailList = [];
                    return;
                }
                this.emailList = response?.map((x) => ({
                    id: x?.id ?? 0,
                    name: x.name ? x.name : x.emailId,
                    emailAddress: x.emailId,
                }));
                if (this.emailList?.length) {
                    this.emailList = this.emailList.filter((c) => {
                        if (!query) {
                            return true;
                        }

                        return c.name?.toLowerCase().startsWith(query.toLowerCase());
                    });
                }
            });
        } else {
            this.emailList = [];
        }
    }

    onKeyUp(event: KeyboardEvent, recipType) {
        if (event.key == "Enter" || event.key == "Tab") {
            let tokenInput = event.srcElement as any;
            if (tokenInput.value) {
                let obj: EmailAddress = this.allRecipients.filter((r) => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
                this.validEmailCheck = checkValidEmail(tokenInput.value);
                if (!obj && this.validEmailCheck) {
                    obj = {
                        id: 0,
                        name: tokenInput.value,
                        emailAddress: tokenInput.value,
                    };
                }
                if (recipType === "to" && obj) {
                    this.toRecipients.push(obj);
                } else if (recipType === "tocc" && obj) {
                    this.ccRecipients.push(obj);
                } else if (recipType === "bcc" && obj) {
                    this.bccRecipients.push(obj);
                }
                let recips = JSON.parse(JSON.stringify(this.allRecipients));
                obj && recips.push(obj);
                this.allRecipients = recips;
                tokenInput.value = "";
            }
        }
    }

    onBlur(event: KeyboardEvent, recipType) {
        let tokenInput = event.srcElement as any;
        if (tokenInput.value) {
            let obj: EmailAddress = this.allRecipients.filter((r) => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
            this.validEmailCheck = checkValidEmail(tokenInput.value);
            if (!obj && this.validEmailCheck) {
                obj = {
                    id: 0,
                    name: tokenInput.value,
                    emailAddress: tokenInput.value,
                };
            }
            if (recipType === "to" && obj) {
                this.toRecipients.push(obj);
            } else if (recipType === "tocc" && obj) {
                this.ccRecipients.push(obj);
            } else if (recipType === "bcc" && obj) {
                this.bccRecipients.push(obj);
            }
            let recips = JSON.parse(JSON.stringify(this.allRecipients));
            obj && recips.push(obj);
            this.allRecipients = recips;
            tokenInput.value = "";
        }
    }

    onToKeyDown(event: KeyboardEvent, recipType?: string): void {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    }
}
